import Sacrificer from './sacrificer.js';

export default class Deceased extends Sacrificer
{       
    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note){ 
        super(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note)

        // Related Data to Deceased
        this.deathCertificate   = null
        this.educations         = null

        this.init()
    }

    setDeathCertificate(deathCertificate){
        this.deathCertificate = deathCertificate
        return this
    }

    setEducations(educations){
        this.educations = educations
        return this
    }
}

